import {
  Box,
  Button,
  Flex,
  JaneGoldIcon,
  Typography,
} from '@iheartjane/reefer';
import type {
  BoxProps,
  ButtonVariant,
  IconSize,
  PaddingProperties,
} from '@iheartjane/reefer';
import { clsx } from 'clsx';

import { JaneGoldLearnMoreLink } from '../janeGoldLearnMoreLink/janeGoldLearnMoreLink';
import styles from './janeGoldUserCallout.module.css';

export interface JaneGoldUserCalloutProps extends PaddingProperties {
  borderRadius?: BoxProps['borderRadius'];
  boxShadow?: boolean;
  branded?: boolean;
  buttonVariant?: ButtonVariant;
  disableMobileStyling?: boolean;
  iconSize?: IconSize;
  isSegmentedDeal?: boolean;
  onLinkAccountClick: () => void;
  showLearnMoreLink?: boolean;
  userHasLinkedBank: boolean;
  userSignedIn: boolean;
}

export const JaneGoldUserCallout = ({
  branded,
  borderRadius = 'lg',
  boxShadow,
  buttonVariant = 'secondary',
  disableMobileStyling = false,
  iconSize = 'md',
  isSegmentedDeal,
  onLinkAccountClick,
  showLearnMoreLink = true,
  userHasLinkedBank,
  userSignedIn,
  ...paddingProps
}: JaneGoldUserCalloutProps) => {
  if (userSignedIn && userHasLinkedBank) {
    return null;
  }

  return (
    <Flex
      className={clsx(styles['calloutContainer'], {
        [styles['calloutContainer__mobile']]: !disableMobileStyling,
        [styles['boxShadow']]: boxShadow,
      })}
      borderRadius={borderRadius}
      border={!boxShadow ? 'transparent-black-ten' : undefined}
      p={24}
      {...paddingProps}
    >
      <Flex>
        <Box>
          <JaneGoldIcon size={iconSize} mr={16} />
        </Box>
        <Typography variant="body-bold" branded={branded}>
          Earn cash back from your favorite cannabis brands with Jane Gold.
        </Typography>
      </Flex>
      {showLearnMoreLink && (
        <JaneGoldLearnMoreLink userHasLinkedBank={userHasLinkedBank} />
      )}
      <Button
        variant={buttonVariant}
        branded={branded}
        label={
          !userSignedIn
            ? isSegmentedDeal
              ? 'Sign in for eligibility'
              : 'Sign in'
            : 'Link bank account'
        }
        onClick={onLinkAccountClick}
      />
    </Flex>
  );
};
